"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriStateCheckbox = exports.TriState = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("./TriStateCheckbox.css");
var TriState;
(function (TriState) {
  TriState[TriState["Partial"] = -1] = "Partial";
  TriState[TriState["Empty"] = 0] = "Empty";
  TriState[TriState["Full"] = 1] = "Full";
})(TriState = exports.TriState || (exports.TriState = {}));
var TriStateCheckbox = function (_a) {
  var className = _a.className,
    _b = _a.value,
    value = _b === void 0 ? TriState.Empty : _b,
    _c = _a.alwaysUpdateInnerCheckboxState,
    alwaysUpdateInnerCheckboxState = _c === void 0 ? false : _c,
    restProps = __rest(_a, ["className", "value", "alwaysUpdateInnerCheckboxState"]);
  var inputRef = (0, react_1.useRef)(null);
  var _updateInnerCheckBoxState = function () {
    if (!inputRef.current) {
      return;
    }
    var checkbox = inputRef.current;
    switch (value) {
      case 0:
        checkbox.checked = false;
        checkbox.indeterminate = false;
        break;
      case 1:
        checkbox.checked = true;
        checkbox.indeterminate = false;
        break;
      default:
        checkbox.checked = false;
        checkbox.indeterminate = true;
        break;
    }
  };
  (0, react_1.useEffect)(function () {
    if (!alwaysUpdateInnerCheckboxState) {
      _updateInnerCheckBoxState();
    }
  }, [value]);
  (0, react_1.useEffect)(function () {
    if (alwaysUpdateInnerCheckboxState) {
      _updateInnerCheckBoxState();
    }
  });
  return (0, jsx_runtime_1.jsx)("input", __assign({}, restProps, {
    className: "vsx-tristatecheckbox ".concat(className),
    type: "checkbox",
    ref: inputRef,
    role: "checkbox"
  }));
};
exports.TriStateCheckbox = TriStateCheckbox;